<template>
  <v-container style="font-family:kalam ; font-size: 16px">
    <v-row class=" pa-2 ma-2" fluid>
      <v-col v-for="(imgObj, i) in featuredImages" :key="i" cols="6">
        <v-card flat align=" center" justify="center" class>
          <img :src="imgObj.imageUrl" :lazy-src="imgObj.imageUrl" height="400" width="auto"
            style="object-fit: cover; align-self: center;" aspect-ratio="16/9" />
          <v-spacer />
          <v-card-text class="fill-height pa-2 d-flex flex-column">
            <v-row>
              <v-col cols>
                <h2>{{ imgObj.title }}</h2>
                <p style="justify-content: center;">{{ imgObj.description }}</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { featuredImages } from '../assets/featured'

export default {
  name: 'FeaturedComp',
  data: () => ({
    featuredImages,
    styleObject: {
      color: 'red',
    }
  }),
}
</script>